import * as React from "react"
import {Box} from "@mui/material";


export default function MUIDataTableActionsToolbar({ children }) {
    return <Box className="MUIDataTableToolbar-customActions" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
		{children}
	</Box>
}
